export enum HttpMethod {
    Post = 'post',
    Get = 'get',
    Put = 'put',
    Delete = 'delete',
    Patch = 'patch'
}
